/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PageControlButtons.vue?vue&type=template&id=3f57fc55"
import script from "./PageControlButtons.vue?vue&type=script&lang=js"
export * from "./PageControlButtons.vue?vue&type=script&lang=js"
import style0 from "./PageControlButtons.vue?vue&type=style&index=0&id=3f57fc55&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports